import { Button } from '@mui/material'

import { useShowMore } from 'src/hooks'
import { useStyles } from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface TableDescriptionColumnProps {
  text: string
}

const TableDescriptionColumn = ({ text }: TableDescriptionColumnProps) => {
  const { expanded, overflowActive, textRef, handleToggle } = useShowMore()
  const classes = useStyles()

  return (
    <div>
      <div ref={textRef} className={expanded ? undefined : classes.descriptionWrapper}>
        {text}
      </div>
      {overflowActive && (
        <Button variant="text" onClick={handleToggle} size="small" sx={{ display: 'inline-flex' }}>
          <HelperWrapper t="expand-button-text" />
        </Button>
      )}
    </div>
  )
}

export { TableDescriptionColumn }
